/** @jsx jsx */
import { SemiTitle } from '@bottlebooks/gatsby-design-system';
import { Col, Container, Row } from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';
import MarketingActivity from './MarketingActivity';

export default function MarketingActivitiesSection({ brand, className }) {
  if (!brand) return null;
  // Manually check for virtual event content.
  if (!brand.marketing?.length) return false;
  return (
    <Section
      sx={{ backgroundColor: 'primary', color: 'onPrimary', paddingY: 4 }}
      className={className}
    >
      <Container>
        <Row
          sx={{
            paddingX: [null, `${100 / 12}%`], // 1 col spacing from medium width up.
          }}
        >
          <Col sx={{ width: ['100%', '70%'] }}>
            <SemiTitle sx={{ borderBottom: 1, paddingY: 3, marginY: 0 }}>
              <Trans>Marketing activities</Trans>
            </SemiTitle>
            {brand.marketing?.length
              ? brand.marketing?.map(marketingActivity => (
                  <MarketingActivity
                    key={marketingActivity.type}
                    variant="onPrimary"
                    activity={marketingActivity}
                    sx={{ borderBottom: 1, borderColor: 'currentColor' }}
                  />
                ))
              : null}
          </Col>
        </Row>
      </Container>
    </Section>
  );
}

export const fragment = graphql`
  fragment MarketingActivitiesSection on AbstractBrand {
    marketing {
      ...MarketingActivity
    }
  }
`;
